import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {Button, Descriptions, Image} from "antd";
import {SpecimenEntity} from "../../entity/specimen-entity";
import {BaseImageUrl} from "../../http/http";
import {
    downLoadImageByUrl,
    getBase64Background,
    getImageName,
    getImageUrlName,
    operationPicture
} from "../../utils/imageUtil";
import watermark from "../../utils";
import {getWaterMarkImage} from "../../http/manager";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../config/serviceLoading";

interface PlantDetailProps {
    detail:SpecimenEntity;
}

const defaultIcon = require("../../image/default-pic.png")

const PlantDetail:React.FC<PlantDetailProps> = ({detail}) => {

    const [loadImageUrl, setLoadImageUrl] = useState("");

    useEffect(()=> {
        getWaterMarkPicture();
    }, [])

    const downloadImage = () => {
        downLoadImageByUrl(BaseImageUrl+detail.imgUrl, getImageUrlName(detail.imgUrl))
    }

    const getWaterMarkPicture = () => {
        const param = {
            imageName: getImageName(detail.imgUrl),
        }
        showFullScreenLoading()
        getWaterMarkImage(param)
            .then((res) => {
                tryHideFullScreenLoading()
                setLoadImageUrl(BaseImageUrl+detail.imgUrl);
            })
            .catch(() => {
                tryHideFullScreenLoading();
            })
    }

    return (<Wrapper>
            <div className="imgBox">
                <Image width={"500px"} src={loadImageUrl} fallback={defaultIcon}/>
            </div>
            <InfoWrapper>
                <Button onClick={downloadImage} style={{width:"100px", marginLeft:"35px", marginBottom:"20px"}} type={"primary"}>下载图片</Button>
                <Descriptions style={{marginLeft: "35px"}} title={"采集信息"} size={"middle"} layout={"horizontal"} bordered={true} column={1}>
                    <Descriptions.Item label={"种中文名"}>{detail.specimenName}</Descriptions.Item>
                    <Descriptions.Item label={"种拉丁文"}>{detail.specimenCanonicalName}</Descriptions.Item>
                    <Descriptions.Item label={"采集人"}>{detail.gatherer}</Descriptions.Item>
                    <Descriptions.Item label={"采集号"}>{detail.gatherNumber}</Descriptions.Item>
                    <Descriptions.Item label={"采集日期"}>{detail.gatherDate}</Descriptions.Item>
                    <Descriptions.Item label={"省市"}>{detail.province}</Descriptions.Item>
                    <Descriptions.Item label={"区县"}>{detail.district}</Descriptions.Item>
                    {/*<Descriptions.Item label={"地名"}>{detail.specimenName}</Descriptions.Item>*/}
                </Descriptions>
                <Descriptions style={{marginLeft: "35px", marginTop:"40px"}} title={"鉴定信息"} size={"middle"} layout={"horizontal"} bordered={true} column={1}>
                    <Descriptions.Item label={"鉴定人"}>{detail.authenticateEr}</Descriptions.Item>
                    <Descriptions.Item label={"鉴定时间"}>{detail.authenticateDate}</Descriptions.Item>
                </Descriptions>
            </InfoWrapper>
        </Wrapper>);
}
export default observer(PlantDetail);


const Wrapper = styled.div`
  & {
    display: flex;
    max-height: 800px;
    overflow: auto;
    flex-direction: row;
    padding: 15px;
    .ant-descriptions.ant-descriptions-bordered .ant-descriptions-item-label {
      background-color: #F9FAFD;
    }
    .ant-descriptions .ant-descriptions-item-content{
      color: #666666;
    }
    .imgBox {
        width: 500px;
        border-radius: 8px;
        border: 1px solid rgba(5, 5, 5, 0.06);
        display: flex;
        align-items: center;
    }
  }
`;
const InfoWrapper = styled.div`

  & {
    display: flex;
    flex-direction: column;
  }
`;